import { Tooltip, } from "@material-ui/core";
import { useTooltipCommonStyles } from "../styles/tooltipCommonStyles";
import { IoMdWarning, IoMdCheckmark } from "react-icons/io";
import React, { useState } from "react";
import { openTooltip } from "../helpers";
import { IRefundTransactionProduct, ITooltipParams } from "../contracts";

export function ToolTipProcessStatus({ row, item }: ITooltipParams) {
    const tooltipClass = useTooltipCommonStyles();
    const [open, setOpen] = useState<boolean>(false);
    const pbmSalesProducts: IRefundTransactionProduct[] = row?.original?.pbmSalesProducts;
    pbmSalesProducts?.forEach(product => {
        if (product.refundStatus === "CALCULATED") product.refundStatus = "CALCULADA";
        if (product.refundStatus === "NO_RULE") product.refundStatus = "SEM REGRA";
        if (product.refundStatus === "NO_FORMULA") product.refundStatus = "SEM FÓRMULA";
        if (product.refundStatus === "RECALCULATED") product.refundStatus = "RECALCULADA";
    });
    
    const productItem = pbmSalesProducts ? pbmSalesProducts[0][item] : null;
    const titleTooltipStyle: React.CSSProperties = {
        borderRadius: "6px", 
        textAlign: "center", 
        color: "white", 
        padding: "5px", 
        marginTop: "2px",
    };
    const iconStyle: React.CSSProperties = {
        marginLeft: "8px", 
        fontSize: "18px",
        cursor: "pointer"
    };
    
    if (pbmSalesProducts?.length > 1) {
      const productItens = pbmSalesProducts?.map((pbmSaleProduct) => {
        return pbmSaleProduct[item];
      }); 

      const content = 
        <div style={{maxHeight: "100px", overflowY: "auto"}}>
            {productItens.map((value, index) => {
                const valueExists = value !== "0" ? value : "-";
                return (
                    <div style={{backgroundColor: value !== "CALCULADA" && value !== "RECALCULADA" ? "#eb3737" : "#9ACD32",
                    marginRight: "10px",
                        ...titleTooltipStyle
                    }} key={index}>
                        {index+1}: {valueExists + `${pbmSalesProducts[index].refundError !== "0" ? ` (${pbmSalesProducts[index].refundError})` : ''}`} 
                    </div>
                )
                })
            }
        </div>;

      return (
        
        <Tooltip classes={{tooltip: tooltipClass.customTooltip}} arrow placement="right" 
        open={open}
        title= {content}>
            <div style={{display: "flex", alignItems: "center", width: "100px"}}>
                <a style={{cursor: "pointer", textDecoration: "underline", color: row?.original?.containsProblem ? "red" : "#7eb80b"}}
                onClick={() => openTooltip(open, setOpen)}>
                    {open ? "ver menos" : "ver mais ..."}
                </a>
                {row?.original?.containsProblem ? 
                <span style={{color: "#eb3737", ...iconStyle}}>
                    <IoMdWarning/>
                </span> : 
                <span style={{color: "#7eb80b", ...iconStyle}}>
                    <IoMdCheckmark/>
                </span>}
            </div>
        </Tooltip> 
      );
    }

    const productItemExists = productItem !== "0" ? productItem : "-";
    return (
        <Tooltip classes={{tooltip: tooltipClass.customTooltip}} arrow placement="right"  
        title = {`${pbmSalesProducts[0].refundError !== "0" ? ` (${pbmSalesProducts[0].refundError})` : ''}`}>
            <span style={{
                backgroundColor: productItem !== "CALCULADA" && productItem !== "RECALCULADA" ? "#eb3737" : "#9ACD32",
                ...titleTooltipStyle}}>
                    {productItem ? productItemExists : 'carregando...'}
            </span>
        </Tooltip>
    );
  }